import React from "react";

export function formatFilterLabelText(
    labels: string[],
    pluralNoun?: string,
): string | null {
    if (labels.length === 0) {
        return null;
    }

    if (labels.length === 1) {
        return labels[0];
    }

    if (pluralNoun) {
        return `${labels.length} ${pluralNoun}`;
    }

    if (labels.length === 2) {
        return labels.join(", ");
    }

    return `${labels[0]} and ${labels.length - 1} others`;
}

export function formatFilterLabel(labels: string[]): React.ReactNode | null {
    const text = formatFilterLabelText(labels);

    if (text === null) {
        return null;
    }

    return <span>{text}</span>;
}
